var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"register"}},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v("JOFPH  后台管理")]),_c('h5',[_vm._v("用户注册")]),_c('a-form',{attrs:{"form":_vm.form,"layout":"horizontal"},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',[_c('div',{staticClass:"input"},[_c('a-icon',{attrs:{"type":"user"}}),_c('input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'username',
              {
                rules: [
                  {
                    required: true,
                    message: '账号不得为空!',
                  },
                ],
              },
            ]),expression:"[\n              'username',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '账号不得为空!',\n                  },\n                ],\n              },\n            ]"}],attrs:{"placeholder":"请输入用户账号"}})],1)]),_c('a-form-item',[_c('div',{staticClass:"input"},[_c('a-icon',{attrs:{"type":"lock"}}),_c('input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'password',
              {
                rules: [
                  {
                    required: true,
                    message: '密码不得为空!',
                  },
                ],
              },
            ]),expression:"[\n              'password',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '密码不得为空!',\n                  },\n                ],\n              },\n            ]"}],attrs:{"placeholder":"请输入用户密码","type":"password"}})],1)]),_c('a-form-item',[_c('div',{staticClass:"input"},[_c('a-icon',{attrs:{"type":"lock"}}),_c('input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'repassword',
              {
                rules: [
                  {
                    required: true,
                    message: '确认密码不得为空!',
                  },
                  {
                    validator: _vm.compareToFirstPassword,
                  },
                ],
              },
            ]),expression:"[\n              'repassword',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '确认密码不得为空!',\n                  },\n                  {\n                    validator: compareToFirstPassword,\n                  },\n                ],\n              },\n            ]"}],attrs:{"placeholder":"请确认用户密码","type":"password"}})],1)]),_c('a-form-item',[_c('div',{staticClass:"input"},[_c('a-icon',{attrs:{"type":"smile"}}),_c('input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'nickname',
              {
                rules: [
                  {
                    required: true,
                    message: '用户姓名不得为空!',
                  },
                ],
              },
            ]),expression:"[\n              'nickname',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: '用户姓名不得为空!',\n                  },\n                ],\n              },\n            ]"}],attrs:{"placeholder":"请输入用户姓名"}})],1)]),_c('a-form-item',[_c('div',{staticClass:"input"},[_c('a-icon',{attrs:{"type":"mail"}}),_c('input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
              'email',
              {
                rules: [
                  {
                    type: 'email',
                    message: '请输入正确的邮箱地址!',
                  },
                  {
                    required: true,
                    message: '邮箱地址不得为空!',
                  },
                ],
              },
            ]),expression:"[\n              'email',\n              {\n                rules: [\n                  {\n                    type: 'email',\n                    message: '请输入正确的邮箱地址!',\n                  },\n                  {\n                    required: true,\n                    message: '邮箱地址不得为空!',\n                  },\n                ],\n              },\n            ]"}],attrs:{"placeholder":"请输入邮箱地址"}})],1)]),_c('router-link',{attrs:{"to":"/access/login"}},[_vm._v("返回登录")]),_c('a-form-item',[_c('a-button',{attrs:{"type":"primary","html-type":"submit"}},[_vm._v(" 立即注册 ")])],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }